export enum NotificationTypes {
  newfile = 'newfile',
  newdownload = 'newdownload',
  newnote = 'newnote',
  modifiednote = 'modifiednote',
  sharedfile = 'sharedfile',
}
